import React from 'react'

export default function List(props) {
    return (
        <div className="text list">
            {props.places.map(place=>{
                return <div value={place} onClick={(event)=>{
                    props.selectPlace(event);
                    props.closeDrawer();
                }}>
                    <p value={place}>{place}</p>
                </div>
            })}
        </div>
    )
}
